import {CustomerEntityType,} from '../../const';
import {  getCustomerEntityTypes} from '../../const';

export const CustomerEntityTypeValueOptions: CustomerEntityTypeValue[] = getCustomerEntityTypes();

export type CustomerEntityTypeValue = CustomerEntityType | null;
